/**
 * Discriminator for every query source a project can execute queries against.
 * A query source is anything that can scan a schema and run a query returning
 * the standard table format (ResultColumns + rows behind a queryUuid): the
 * project warehouse, the semantic layer, the DuckDB compose engine, and —
 * later — CSV uploads, HTTP APIs, Google Sheets, etc.
 *
 * Deliberately NOT WarehouseTypes: sources are not warehouses, they plug in
 * above the warehouse client layer.
 */
export var QuerySourceType;
(function (QuerySourceType) {
    /** Metric queries compiled through the project's semantic layer. */
    QuerySourceType["SEMANTIC_LAYER"] = "semanticLayer";
    /** Raw SQL against the project's data warehouse (SQL runner). */
    QuerySourceType["SQL"] = "sql";
    /**
     * DuckDB SQL over previous results (compose engine). References expose
     * other queries' results as named tables, so this is the merge/transform
     * step of a multi-source pipeline.
     */
    QuerySourceType["DUCKDB"] = "duckdb";
    /** Durable external tables queried with DuckDB; enterprise only. */
    QuerySourceType["EXTERNAL"] = "external";
})(QuerySourceType || (QuerySourceType = {}));
//# sourceMappingURL=querySources.js.map